import { render, staticRenderFns } from "./ACS.vue?vue&type=template&id=70e0fc47&scoped=true&"
import script from "./ACS.vue?vue&type=script&lang=js&"
export * from "./ACS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e0fc47",
  null
  
)

export default component.exports